package dev.kuml.portal.web.i18n.strings

/** R-26: strings for the "Projekt-Dateien"-Panel ([dev.kuml.portal.web.editor.EditorScreen]'s
 * persistent file store panel). */
public interface ProjectFilesStrings {
    public val panelHeading: String
    public val emptyHint: String
    public val uploadButton: String
    public val uploading: String
    public val uploadFailed: String
    public val descriptionPlaceholder: String
    public val deleteButton: String
    public val deleteConfirmQuestion: String
    public val editDescriptionButton: String
    public val saveButton: String
    public val cancelButton: String
    public val viewIndexLink: String
    public val indexDialogTitle: String
    public val closeButton: String
    public val downloadLink: String

    public val allPlainStrings: List<String>
        get() =
            listOf(
                panelHeading,
                emptyHint,
                uploadButton,
                uploading,
                uploadFailed,
                descriptionPlaceholder,
                deleteButton,
                deleteConfirmQuestion,
                editDescriptionButton,
                saveButton,
                cancelButton,
                viewIndexLink,
                indexDialogTitle,
                closeButton,
                downloadLink,
            )
}

public object ProjectFilesStringsDe : ProjectFilesStrings {
    override val panelHeading = "Projekt-Dateien"
    override val emptyHint = "Noch keine Dateien in diesem Projekt. Laden Sie Referenzmaterial für den KI-Assistenten hoch."
    override val uploadButton = "Datei hochladen"
    override val uploading = "Wird hochgeladen …"
    override val uploadFailed = "Die Datei konnte nicht hochgeladen werden."
    override val descriptionPlaceholder = "Kurzbeschreibung (optional)"
    override val deleteButton = "Löschen"
    override val deleteConfirmQuestion = "Diese Datei löschen? Das kann nicht rückgängig gemacht werden."
    override val editDescriptionButton = "Beschreibung bearbeiten"
    override val saveButton = "Speichern"
    override val cancelButton = "Abbrechen"
    override val viewIndexLink = "INDEX.md ansehen"
    override val indexDialogTitle = "Datei-Index dieses Projekts"
    override val closeButton = "Schließen"
    override val downloadLink = "Herunterladen"
}

public object ProjectFilesStringsEn : ProjectFilesStrings {
    override val panelHeading = "Project files"
    override val emptyHint = "No files in this project yet. Upload reference material for the AI assistant."
    override val uploadButton = "Upload file"
    override val uploading = "Uploading …"
    override val uploadFailed = "The file could not be uploaded."
    override val descriptionPlaceholder = "Short description (optional)"
    override val deleteButton = "Delete"
    override val deleteConfirmQuestion = "Delete this file? This cannot be undone."
    override val editDescriptionButton = "Edit description"
    override val saveButton = "Save"
    override val cancelButton = "Cancel"
    override val viewIndexLink = "View INDEX.md"
    override val indexDialogTitle = "This project's file index"
    override val closeButton = "Close"
    override val downloadLink = "Download"
}
